import React, { Component } from 'react';
import { Tooltip } from 'react-tippy';
import moment from 'moment';
import actions from '../../redux/actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class PriceBreakdown extends Component {
    render() {
        const { sellPrices, currency, showChild } = this.props;
        const priceTable = sellPrices.map((currentDay, index) => {
            return (
                <div className="body-tr" key={'price-day-' + index}>
                    <div className="body-cell">{moment(currentDay.date).format('DD / MMM')}</div>
                    <div className="body-cell">{currentDay.day}</div>
                    <div className="body-cell rate">
                        <Tooltip
                            title={currentDay.discountText}
                            disabled={!currentDay.discountText}
                            position="right"
                            animation="fade"
                            animateFill={false}
                            duration={95}
                            size="big"
                            arrow
                            arrowSize="small"
                            distance={8}>
                            <span className={currentDay.discountText && 'discount'}>
                                {new Intl.NumberFormat('en-GB', {
                                    style: 'currency',
                                    currency: currency,
                                    currencyDisplay: 'code'
                                }).format(currentDay.adultRate)}
                                {currentDay.discountText && <i className="fas fa-exclamation-circle" />}
                            </span>
                        </Tooltip>
                    </div>
                    {showChild && (
                        <div className="body-cell rate">
                            {new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: currency,
                                currencyDisplay: 'code'
                            }).format(currentDay.childRate)}
                        </div>
                    )}
                </div>
            );
        });
        return (
            <div className="body">
                <div className="sub-header">
                    <div className="sub-header-cell date" />
                    <div className="sub-header-cell day" />
                    <div className="sub-header-cell rate">Price per Adult</div>
                    {showChild && <div className="sub-header-cell rate">Price per Child</div>}
                </div>
                {priceTable}
            </div>
        );
    }
}

function mapStateToProps(state) {
    const model = state.xml || [];
    return {
        model,
        settings: state.settings,
        token: state.oidc.user !== null ? state.oidc.user.id_token : ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PriceBreakdown);
